import React from "react";
import * as BosFilesServices from "data/BosWebServices/BosFilesServices";

export default function WebResourceImage(props) {
  const { fileId, fallBackImage, size, style, ...rest } = props;
  let image = fileId ? BosFilesServices.getWebResourceUrl(fileId) : fallBackImage;

  return (
    <img src={image} alt="" style={{ ...style, height: size }} {...rest} />
  );
}
